import { assert } from "@jugl-web/utils";
import { FC } from "react";
import { useClientSupportPageContext } from "../../providers/ClientSupportPageProvider/useClientSupportPageContext";
import { TicketsViewProvider } from "../../providers/TicketsViewProvider";
import { TicketsViewContent } from "./components/TicketsViewContent";
import { TicketsViewTopBar } from "./components/TicketsViewTopBar";

export const TicketsView: FC = () => {
  const { selectedView } = useClientSupportPageContext();

  assert(selectedView.kind === "tickets", "Selected view must be tickets");

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <TicketsViewProvider filter={selectedView.filter}>
        <TicketsViewTopBar ticketsView={selectedView} />
        <TicketsViewContent ticketsView={selectedView} />
      </TicketsViewProvider>
    </div>
  );
};
